export const ENV = {
  AUTH_SERVICE_URL: import.meta.env['VITE_AUTH_SERVICE_URL'] || 'http://localhost:5001/api/auth',

  USER_SERVICE_URL: import.meta.env['VITE_USER_SERVICE_URL'] || 'http://localhost:5002',

  REGISTRATION_SERVICE_URL:
    import.meta.env['VITE_REGISTRATION_SERVICE_URL'] || 'http://localhost:5003',

  INSPECTION_SERVICE_URL: import.meta.env['VITE_INSPECTION_SERVICE_URL'] || 'http://localhost:5007',

  CHECKLIST_SERVICE_URL:
    import.meta.env['VITE_CHECKLIST_SERVICE_URL'] || 'http://localhost:5006',

  NOTIFICATION_SERVICE_URL:
    import.meta.env['VITE_NOTIFICATION_SERVICE_URL'] || 'http://localhost:5008',

  SCRAPER_SERVICE_URL:
    import.meta.env['VITE_SCRAPER_SERVICE_URL'] || 'http://localhost:8000',

  API_TIMEOUT: parseInt(import.meta.env['VITE_API_TIMEOUT'] || '100000'),
} as const;
